import BigNumber from 'bignumber.js'
import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Button, Heading, Text, Link, Flex } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import SearchSelect from 'components/SearchSelectModal/SearchSelect'
import CreateBasic from './CreateBasic'
import CreateLiqudityGenerator from './CreateLiqudityGenerator'
import CreateAnnuity from './CreateAnnuity'
import CreateMultiMint from './CreateMultiMint'
import CreateInscriptions from './CreateInscriptions'

const StyledContainer = styled.div`
  text-align: center;
  position: relative;
`;

const Content = styled.div`
  display: inline-block;
  background: ${({ theme }) => (theme.isDark ? 'rgb(44, 41, 38)' : 'white')};
  box-shadow: 2px 2px 8px ${({ theme }) => (theme.isDark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)')};
  border-radius: 32px;
  padding: 30px 25px;
  position: relative;
  width: 600px;

  @media (max-width: 700px) {
    width: 100%;
    padding: 30px 15px;
  }
`

const StyledLinkContainer = styled(Text)`
  margin-bottom: 40px;
`

const StyledLink = styled(Link)`
  display: inline;
  font-size: inherit;
  margin-left: 5px;
`

const TypeSelectContainer = styled.div`

`

const Label = styled(Text)`
  text-align: left;
  padding-left: 16px;
  margin-bottom: 5px;
`

interface CreateProps {
    onSuccess?: any
}

const Create: React.FC<CreateProps> = ({ onSuccess }) => {
    const TranslateString = useI18n();
    const { account } = useWallet();
    const Templates = {
        "Basic": [TranslateString(408,'Basic'), "/images/sep20/tokens.png"],
        "LiquidityGenerator": [TranslateString(523,'Liquidity Generator'), "/images/sep20/water-drop.png"],
        "Annuity": [TranslateString(1031,'Annuity'), "/images/sep20/annuities.png"],
        "MultiMint": [TranslateString(1443,'MultiMint'), "/images/sep20/team.png"],
        "Inscriptions": [TranslateString(1524,'Inscriptions'), "/images/sep20/eye-of-horus.png"]
    }
    const options = Object.keys(Templates).map((k)=>{return {
        name: Templates[k][0],
        image: Templates[k][1],
        id: k
    }});
    const [template, setTemplate] = useState(Object.keys(Templates)[0]);
    const selected = options.find(p=>p.id===template) || options[0];

    const handleOptionChange = (option) => {
      setTemplate(option.id)
    }

    const renderTypeSelection =() => {
        return  <Flex style={{height:"72px"}}>
          <SearchSelect selected={selected} options={options} onSelect={handleOptionChange}/>
        </Flex>
    }

    const renderTokenTemplate = () => {
        if (template==="Basic") return <CreateBasic onSuccess={onSuccess} />;
        if (template==="LiquidityGenerator") return <CreateLiqudityGenerator onSuccess={onSuccess} />;
        if (template==="Annuity") return <CreateAnnuity onSuccess={onSuccess} />;
        if (template==="MultiMint") return <CreateMultiMint onSuccess={onSuccess} />;
        if (template==="Inscriptions") return <CreateInscriptions onSuccess={onSuccess} />;

        return "";
    }

    return (
        <StyledContainer>
            <StyledLinkContainer>
                {TranslateString(311,'Read more in the')}<StyledLink external href={`https://docs.benswap.cash/${TranslateString(1330,'')}features/sep-20-factory`} bold={false}>{TranslateString(312,'documentation')}</StyledLink>{TranslateString(1107, '.')}
            </StyledLinkContainer>
            <div>
                <Content>
                    <TypeSelectContainer>
                        <Label>{TranslateString(1228, 'Token Template:')}</Label>
                        {renderTypeSelection()}
                    </TypeSelectContainer>
                    {renderTokenTemplate()}
                </Content>
            </div>
        </StyledContainer>
    )
}

export default Create
 